import API from 'services/api';

export const updateProfileDetails = ({ payload }: { payload: any }) =>
  API.put(`/api/profile/details`, payload);
